import React from 'react';
import PropTypes from 'prop-types';

import Button from '../Button/Button';
import Icon from '../Icon/Icon';

import HeaderMegaMenuBack from './HeaderMegaMenuBack';

const HeaderMegaMenuSubmenu = ({
  children,
  columns,
  hideViewAll,
  isOpen,
  onClose,
  title,
}) => <div className={`c-header-mega-menu__submenu  ${isOpen ? 'is-open' : ''}`}>
    <HeaderMegaMenuBack title={title} onClick={onClose} />
    <ul
      className={`o-list-bare  c-header-nav__list  ${
        columns
          ? `c-header-nav__list--col-gap  c-header-nav__list--col-${columns}`
          : ''
      }`}
    >
      {children}
    </ul>
    {!hideViewAll && (
      <Button
        color="subtle"
        href="#"
        className="c-header-nav__link  c-header-nav__link--view-all"
      >
        View all <span className="u-hide-visually">{title}</span>
        <Icon
          icon="arrow-right"
          className="c-header-nav__icon  c-header-nav__icon--right  c-header-nav__icon--tiny  u-show@desktop"
        />
      </Button>
    )}
  </div>

export default HeaderMegaMenuSubmenu;

HeaderMegaMenuSubmenu.propTypes = {
  children: PropTypes.node.isRequired,
  columns: PropTypes.number,
  hideViewAll: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};
